import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, GridRequestDto } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetDocumentsCommand extends IRequestCommand<
  IGetDocumentsParameters,
  ErrorDetails,
  IGetDocumentsResponse
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/carrierUser/{carrierUserId}/documents/paginated?page={page}&size={size}&column={column}&sort={sort}&find={find}&module={module}&document={document}';

  public override setParameters(parameters: IGetDocumentsParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId ? parameters.carrierUserId.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{page}',
      parameters.page ? parameters.page.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{size}',
      parameters.size ? parameters.size.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{column}',
      parameters.column ? parameters.column.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{sort}',
      parameters.sort ? parameters.sort.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{find}',
      parameters.find ? parameters.find.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{module}',
      parameters.module ? parameters.module.toString() : ''
    );
    this._commandUrl = this._commandUrl.replace(
      '{document}',
      parameters.document ? parameters.document.toString() : ''
    );
  }
}

export interface IGetDocumentsParameters extends ICommandParameters, GridRequestDto {
  module: string,
  document: string
}

export interface IGetDocumentsResponse extends ICommandResponse {}
